import { Link } from "react-router-dom";
import { Reveal } from "../Reveal";
import FeatureOrb, { MoreOrb } from "../FeatureOrb";
import { AUTOMATION_CATEGORIES, SOFTWARE_CATEGORIES } from "../../data/features";

export default function FeatureGrid() {
  return (
    <section
      id="products"
      data-testid="feature-grid-section"
      className="relative py-24 md:py-32 border-t border-[#E6E9F1] bg-white"
    >
      <div className="mb-blob mb-blob-orange mb-anim-a w-[320px] h-[320px] -top-20 right-0" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tighter leading-none text-[#0B1533]">
            Every channel, <span className="text-[#FF6B00]">one dashboard</span>
          </h2>
          <p className="mt-5 text-base md:text-lg text-[#475569] leading-relaxed">
            Every AI channel is fully white-label and billable as its own line item.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 gap-x-4 gap-y-10 lg:grid-cols-4 lg:gap-x-8">
          {AUTOMATION_CATEGORIES.map((cat, i) => (
            <Reveal key={cat.id} delay={i * 0.08} className="h-full">
              <FeatureOrb cat={cat} big testId="feature-grid-card-big" />
            </Reveal>
          ))}
        </div>

        <Reveal className="mx-auto mt-24 max-w-2xl text-center">
          <h3 className="text-2xl md:text-3xl font-extrabold tracking-tighter leading-none text-[#0B1533]">
            Included with Powerful Features
          </h3>
          <p className="mt-5 text-base md:text-lg text-[#475569] leading-relaxed">
            Standalone software bundled in at no extra cost, ready to sell as your own.
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-2 gap-x-4 gap-y-10 md:grid-cols-3 lg:grid-cols-4 lg:gap-x-8">
          {SOFTWARE_CATEGORIES.map((cat, i) => (
            <Reveal key={cat.id} delay={(i % 4) * 0.06} className="h-full">
              <FeatureOrb cat={cat} testId="feature-grid-card" />
            </Reveal>
          ))}
          <Reveal delay={(SOFTWARE_CATEGORIES.length % 4) * 0.06} className="h-full">
            <MoreOrb to="/features" label="See every tool" testId="feature-grid-card-more" />
          </Reveal>
        </div>

        <Reveal delay={0.15} className="mt-12 text-center">
          <Link
            to="/features"
            data-testid="explore-features-link"
            className="inline-flex items-center gap-2 text-sm font-semibold text-[#FF6B00] hover:gap-3 transition-all"
          >
            See every feature in detail
            <span aria-hidden>→</span>
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
